// services/detalleService.js
// entity factory / constructor de entidad
// valida reglas de negocio específicas del detalle
// no hace llamadas a repositorios ni otras entidades

export function construirDetalle({ producto }) {
  if (!producto) throw new Error("Producto requerido");

  return {
    id_producto: producto.id,
    nombre_producto: producto.nombre,
    cantidad: producto.cantidad,
    precio_unitario: producto.precio,
    subtotal: producto.cantidad * producto.precio,
    estado: "activo",
    fecha_registro: new Date().toISOString(),
  };
}
